var map = {
	"./ava_program_ikon.svg": 6349,
	"./galeria_program_ikon.svg": 322,
	"./jamh_program_ikon.svg": 3599,
	"./kbmo_program_ikon.svg": 5354,
	"./ktkh_program_ikon.svg": 2403,
	"./pmh_program_ikon.svg": 4910,
	"./szimh_program_ikon.svg": 4878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;